// extracted by mini-css-extract-plugin
export default {"InformationBox":"InformationBox_InformationBox__rcT8a"};